<FormInput
        v-model="filterValue"
        :attributes="{placeholder:'Поиск сценариев'}"
/>
<FormCheckbox label="Показать удалённые" v-model="showRemovedValue" class="mt-1" />
